import { Container, HStack, VStack, useBreakpointValue } from "@chakra-ui/react";
import { FC } from "react";
import { BlockContainer } from "src/atoms";
import Renderer from "src/lib/renderer";
import FeatureGrid from "./components/FeatureGrid";
import FeatureCarousel from "./components/FeatureCarousel";

import { Element } from "@prismicio/react";
import { heading2, heading4, heading5 } from "src/lib/renderer/elements/headings";
import paragraph from "src/lib/renderer/elements/paragraph";

const BlockFeatureCarousel: FC<
  Gatsby.PageBlockFeatureCarouselFragment
> = ({ primary, items }) => {
  if (!primary || !items) {
    throw Error();
  }

  const { content, is_marketech: isMarketech } = primary;

  const isGrid = items.length <= 3;
  const isMobile = useBreakpointValue({
    base: true,
    xs: true,
    sm: true,
    md: false,
    lg: false,
    xl: false,
    "2xl": false,
    "3xl": false,
  });
  return (
    <BlockContainer
      paddingX="0"
      sx={{
        "> *": {
          maxWidth: { base: "100vw", md: "100%" },
        },
      }}
      wrapperContainerProps={{
        paddingX: 0,
        overflow: "hidden",
      }}
    >
      <VStack spacing="space-0">
        <Container size="block" paddingY="0">

          {isMarketech ? null : (
            <Container variant="heading">
              <VStack
                spacing={{ base: "space-16" }}
                maxW={{ base: "480px", md: "full" }}
                mx="auto"
              >
                <Renderer
                  overrides={{
                    [Element.heading2]: (args) =>
                      heading2({
                        ...args,
                        overrideProps: {
                          marginBottom: 0,
                        },
                      }),
                    [Element.heading3]: (args) =>
                      heading5({
                        ...args,
                        overrideProps: { marginBottom: 0, color: "text-subheader", variant: "heading-5" },
                      }),
                  }}
                  field={content}
                />
              </VStack>
            </Container>
          )}

        </Container>

        <FeatureGrid
          items={items}
          primary={primary}
          display={{ base: "none", lg: isGrid ? "flex" : "none" }}
          isMarketech={isMarketech}
        />
        <FeatureCarousel
          items={items}
          primary={primary}
          display={{ lg: isGrid ? "none" : "flex" }}
          title={content}
          isMarketech={isMarketech}
        />
      </VStack>
    </BlockContainer>
  );
};

export default BlockFeatureCarousel;
